import $ from "jquery";
import React from 'react';
import { Button, Modal, Input } from 'semantic-ui-react';

import Loading from '../../loading';
import Server from '../../../functions/server';

class AddExpenseMaster extends React.Component {

  state = {
    expenseName: '', load: false, message: '', hsncode: '', tax: ''
  }

  AddExpense() {
    let context = this;
    let { expenseName, hsncode, tax } = this.state;
    let data = { expenseName, 'eid': 1, hsncode, tax };
    let url = Server() + 'WebMaster/ExpenseMaster/add.php';
    if (this.props.edit == '1') {
        data = { expenseName, 'mid': context.state.mid, hsncode, tax };
        url = Server() + 'WebMaster/ExpenseMaster/editname.php';
    }
    console.log(url);
    console.log(data);
    context.setState({ load: true })
    $.ajax({
      type: 'POST', data, url,
      success: function(data) {
        console.log(data);
        if (data == 1) {
            context.props.GetExpenseMaster();
            context.setState({ addExpense: false, expenseName: '', load: false })
        }
        else {
            context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  onChangeText = (type) => (e, {value}) => { this.setState({ [type]: value }) }

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        { this.props.edit == '1' ?
            (<center onClick={ () => { 
              this.setState({ 
                addExpense: true, 
                expenseName: this.props.name, 
                mid: this.props.mid,
                hsncode: this.props.item.hsncode, 
                tax: this.props.item.tax
              }) }
            } style={{color: 'blue'}}>Edit</center>):
            (<Button onClick={ () => { this.setState({ addExpense: true }) }}>Add</Button>)
        }
        
        <Modal style={{width: '30%'}} open={this.state.addExpense} onClose={ () => { this.setState({ addExpense: false }) }}>
          <Modal.Header>{'Add Expense'}</Modal.Header>
          <Modal.Content>
                Expense Name<br/>
                <Input fluid onChange={this.onChangeText('expenseName')} value={this.state.expenseName} />
                HSN Code<br/>
                <Input fluid onChange={this.onChangeText('hsncode')} value={this.state.hsncode} />
                Tax<br/>
                <Input fluid onChange={this.onChangeText('tax')} value={this.state.tax} />
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={ () => { this.setState({ addExpense: false }) }} negative>
              Close
            </Button>
            <Button onClick={this.AddExpense.bind(this)} positive labelPosition='right' icon='checkmark' content='Yes' />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default AddExpenseMaster;
